import React from 'react';
import { useSelector } from 'react-redux';
import { css } from '@emotion/core';
import i18n from 'i18next';

import { below } from 'utils/breakpoint';
import { loginTypes } from 'config/loginTypes';
import useLogout from 'client/hooks/logout/useLogout';
import useLogoutRedirect from 'client/hooks/logout/useLogoutRedirect';
import usePromoSettingThemeStyle from 'hooks/useThemeStyleIntegration';
import { gameTypes } from 'config/promoGameTypes';

const { RED_ENVELOPE_RAIN } = gameTypes;

const Logout = ({ customWrapperStyle, customStyle }) => {
    const logout = useLogout();
    const redirectEnterpriseLogout = useLogoutRedirect();
    const themeStyle = usePromoSettingThemeStyle();
    const {
        settingPromo: { loginMethod, enableHideLogoutButton },
        promo: { type: promoType },
        userLoginState: { isLogin },
        userGameResultRecords = [],
        purePrizeState: { isGameReadyToPlay }
    } = useSelector(s => s);
    const hasGameResultRecords = userGameResultRecords.length > 0;
    const shouldHideLogoutButton = (() => {
        if (
            loginMethod !== loginTypes.ANONYMOUSLOGIN &&
            window.location.hostname === 'event.91app.com'
        ) {
            // 登入狀態控制在 91app 上，因此不可以出現登出按鈕 [FV-2574]
            // 91 開放不登入活動，不登入活動顯示登出按鈕 [FV-2830]
            return true;
        } else if (loginMethod === loginTypes.ANONYMOUSLOGIN && !hasGameResultRecords) {
            // 如果不登入，在有參加紀錄（Cookie 記錄）下，才給予登出按鈕
            return true;
        } else if (promoType === RED_ENVELOPE_RAIN && isGameReadyToPlay) {
            // 紅包雨開始遊戲時隱藏登出 [SUPPORT-3582]
            return true;
        } else if (loginMethod === loginTypes.INSTAGRAM) {
            // IG Hashtag 模組不需要登入 / 登出
            return true;
        } else if (loginMethod === loginTypes.ANONYMOUSLOGIN) return true;
        else return Boolean(enableHideLogoutButton);
    })();

    return (
        isLogin &&
        !shouldHideLogoutButton && (
            <div id="fv-promo-footer-logout" css={customWrapperStyle ? null : logoutWrapperStyle}>
                <div
                    onClick={() => logout(redirectEnterpriseLogout)}
                    css={[logoutStyle(themeStyle.titleColor), customStyle]}
                >
                    {i18n.t('label.logout')}
                </div>
            </div>
        )
    );
};

export default Logout;

const logoutWrapperStyle = css`
    margin-top: 18px;
    margin-bottom: 40px;
    padding-right: 10px;
    ${below('sm')} {
        margin-bottom: 20px;
    }
`;

const logoutStyle = textColor => css`
    float: right;
    font-size: 0.875rem;
    cursor: pointer;
    font-weight: 500;
    color: ${textColor};
    position: relative;
    z-index: 0;
    ${below('sm')} {
        float: none;
        text-align: center;
    }
`;
